<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        size="lg"
        :show.sync="show">
        <CRow>
          <CCol>
             <label > <strong> LINK ID : {{ form.id }}  </strong> </label>
             
             <CRow class="mt-3">
    
               <CCol>
                 <label> <strong>{{ "Title: " }} </strong>{{form.title  }} </label>
               </CCol>
                 </CRow>
             <hr>
              <CRow>
                <CCol><label><strong> {{ "URL: " }}</strong> {{form.url }} </label>
                </CCol>
                </CRow>
                
              <hr>
              <CRow><CCol>
                <label> <strong> {{ "Author: " }} </strong> {{ form.author }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow><CCol>

                <label> <strong> {{ "Description: " }} </strong> {{form.description }} </label>
                </CCol>
                </CRow>
              
              <hr>
              <CRow >
                <CCol>
                  <label > <strong>{{ "Department: " }} </strong> {{ form.department.name}} </label>
                </CCol>
                </CRow>
                <hr>
                <CRow >
                <CCol>
                  <label > <strong> {{ "Section: " }} </strong> {{form.section.name}} </label>
                </CCol>
                </CRow>
                <hr>
                <CRow >
                <CCol>
                  <!-- <label > <strong> {{ "Category Sermon: " }} </strong> {{form.category_sermon.name}} </label> -->
                  <label > <strong> {{ "Category Sermon: " }} </strong> </label>
                  <div v-for="item in form.category_sermon" :key="item.value">
                    <label> {{item.text}} </label>
                  </div>
                  
                </CCol>
                </CRow>
                <!-- <hr>
                 <CRow >
                   
                <CCol>
                 <b-form-checkbox 
              class="mt-3"
              id="checkbox-1"
              v-model="form.spotlight"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
              disabled
            >
            <b-icon icon="check" font-scale="1.5"> ></b-icon>  untuk <b>Menyoroti</b> link content ini.
            </b-form-checkbox>
                </CCol>
                </CRow> -->

                <hr>
                <label > <strong> {{ "Image " }} </strong> </label>
              <CRow>
                 
                <CCol> 
             <img v-bind:src="getPhoto(form.get_photo)" width="450" height="200">  
               </CCol>
                </CRow> 
               
               
          </CCol> 
          </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Close</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>

import EventBus from '@/eventBus';
import linkcontent from '@/services/linkcontent'
import axios from 'axios'
import store from '@/store.js'

export default {
name: 'visitormodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      datas:[],
      form:{
        id: '',
        title: '',
        url:'',
        author:'',
        description:'',
        image:'',
        department:'',
        category_sermon:'',
        section:'',
        spotlight:'',
        get_photo:'',
      }
    }
  },
   computed: {

   },
  mounted(){

  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_SHOW_LINK', (params) => {
      if(params.data){
        linkcontent.getLinkContentbyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.id = params.data;
          self.form.title = res.data.title;
          self.form.url = res.data.url;
          self.form.author = res.data.author;
          self.form.description = res.data.description;
          self.form.image = res.data.image;
          self.form.department = res.data.department;
          //self.form.category_sermon = res.data.category_sermon;
          self.form.category_sermon = JSON.parse(res.data.category_sermon);
          self.form.section = res.data.section;
          self.form.spotlight = res.data.spotlight;
          self.form.get_photo = res.data.get_photo;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.title = "";
        self.form.url = "";
        self.form.author = "";
        self.form.description = "";
        self.form.image = "";
        self.form.department = "";
        self.form.category_sermon = "";
        self.form.section = "";
        self.form.spotlight = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    getPhoto(data){
      console.log('get - photo')
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    },   
   
  }
}
</script>
